import { RotateCcw, IndianRupee, Hash } from 'lucide-react';

const RefundStatisticsTab = ({ refundStat }) => {
  const refundCount = refundStat?.refundCount ?? 0;
  const refundAmount = refundStat?.refundAmount ?? 0;

  // console.log("refundStat====>>>", refundStat)

  return (
    <>
      {/* Refund Statistics */}
      <div className='bg-card border border-border rounded-lg p-6'>
        <h2 className='text-lg font-semibold mb-4 flex items-center'>
          <RotateCcw className='mr-2' size={20} />
          Refund History
        </h2>

        <div className='grid grid-cols-1 md:grid-cols-2 gap-4'>
          <div className='bg-orange-500/10 border border-orange-500/20 rounded-lg p-4'>
            <div className='flex items-center justify-between'>
              <label className='text-xs text-muted-foreground'>Total Refunds</label>
              <Hash size={14} className='text-orange-600' />
            </div>
            <p className='text-2xl font-bold text-orange-600 mt-1'>{refundCount}</p>
          </div>

          <div className='bg-red-500/10 border border-red-500/20 rounded-lg p-4'>
            <div className='flex items-center justify-between'>
              <label className='text-xs text-muted-foreground'>Total Refund Amount</label>
              <IndianRupee size={14} className='text-red-600' />
            </div>
            <p className='text-2xl font-bold text-red-600 mt-1'>
              ₹{refundAmount?.toLocaleString() || 0}
            </p>
          </div>
        </div>

        {refundCount === 0 && (
          <p className='text-sm text-muted-foreground mt-4'>No refunds issued for this seller yet.</p>
        )}
      </div>
    </>
  );
};

export default RefundStatisticsTab;